import type { Components, Theme } from '@mui/material'
import { CheckedIcon } from 'assets/icons/checkbox-checked'
import { UncheckedIcon } from 'assets/icons/checkbox-unchecked'

type MuiCheckboxSettings = Components<Omit<Theme, 'components'>>['MuiCheckbox']

export const MuiCheckbox: MuiCheckboxSettings = {
  styleOverrides: {
    root: {
      borderRadius: 8,
      '.MuiSvgIcon-root': {
        borderRadius: '8px', // zmień na dowolną wartość
      },
    },
  },
  defaultProps: {
    checkedIcon: <CheckedIcon />,
    icon: <UncheckedIcon />,
  },
}
